import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap'

import SlideHOC from '../SlideHOC'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

import tipIcon from '../../assets/tipIcon.svg'
import PlayStoreIcon from '../../assets/playstore.svg'
import AppleStoreIcon from '../../assets/appstore.svg'
import './SlideScene.scss'

class SlideScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.bgRef, this.props.duration * 0.95,
        { xPercent: 110 }, { xPercent: 0, delay: this.props.duration * 0.05 })
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { autoAlpha: 0 }, { autoAlpha: 1, delay: this.props.duration * 0.5 }, 0)
      .fromTo(this.tipRef, this.props.duration * 0.5,
        { yPercent: 75 }, { yPercent: 0, delay: this.props.duration * 0.5 }, 0)

    this.inReversedAnimation = new TimelineMax({ paused: true })
      .to(this.bgRef, 0, { xPercent: 0 })
      .to(this.contentRef, 0, { autoAlpha: 1 })
      .to(this.tipRef, 0, { yPercent: 0 })
      .fromTo(this.rootRef, this.props.duration, { autoAlpha: 0, immediateRender: false }, { autoAlpha: 1, zIndex: 10 })
      .fromTo(this.wrapperRef, this.props.duration * 0.9,
        { xPercent: -15, rotationY: 100 }, { xPercent: 0, rotationY: 0 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
      // .fromTo(this.rootRef, this.props.duration,
      //   { zIndex: 1, xPercent: 0, autoAlpha: 1, immediateRender: false }, { autoAlpha: 0 })
      // .fromTo(this.wrapperRef, this.props.duration,
      //   { rotationY: 0, xPercent: 0 }, { xPercent: -15, rotationY: 100 }, 0)
      .fromTo(this.rootRef, this.props.duration, { zIndex: 1 }, { autoAlpha: 0 })
      .to(this.wrapperRef, this.props.duration, { xPercent: -15, rotationY: 100 }, 0)

    this.outReversedAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration, { xPercent: 0, autoAlpha: 1, immediateRender: false }, { xPercent: 110 })
  }

  goToUrl (url) {
    if (url) {
      window.location.href = url
    }
  }

  renderTipContent () {
    const { tip, slideNum, tipType, appLinks } = this.props
    switch (tipType) {
      case 'text':
        return (
          <div className={`aw__slide__tip--text aw_slide__tip_${slideNum}--text`}>{ tip }</div>
        )
      case 'appLinks':
        return (
          <div className='aw_slide__tip--applinks-container'>
            <div id={`aw_slide__tip_${slideNum}--button-1`}
              className={`aw_slide__tip--applink aw_slide__tip_${slideNum}--button-1`}
              style={{backgroundImage: `url(${PlayStoreIcon})`}}
              onClick={e => this.goToUrl(appLinks['google'])}
            />
            <div id={`aw_slide__tip_${slideNum}--button-2`}
              className={`aw_slide__tip--applink aw_slide__tip_${slideNum}--button-2`}
              style={{backgroundImage: `url(${AppleStoreIcon})`}}
              onClick={e => this.goToUrl(appLinks['apple'])}
            />
          </div>
        )
      default:
        return (
          <div className={`aw__slide__tip--text aw_slide__tip_${slideNum}--text`}>{ tip }</div>
        )
    }
  }

  render () {
    // console.log('SlideScene render')
    const { bg, slideNum, title, description } = this.props
    return (
      <div className='aw_slide' ref={ref => (this.rootRef = ref)}>
        <div className='aw_slide__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <div
            id={`aw_slide__bg_${slideNum}`}
            className={`aw_slide__bg aw_slide__bg_${slideNum}`}
            style={{ backgroundImage: `url(${bg})` }}
            ref={ref => (this.bgRef = ref)}
          />

          <div className='aw_slide__content' ref={ref => (this.contentRef = ref)}>
            <div id={`aw_slide__title_${slideNum}`} className={`aw_slide__title aw_slide__title_${slideNum}`}>{ title }</div>
            <div id={`aw_slide__desc_${slideNum}`} className={`aw_slide__description aw_slide__desc_${slideNum}`}>
              <span className={`aw_slide__description--text aw_slide__desc_${slideNum}--text`}>
                { description }
              </span>
            </div>
            <div id={`aw_slide__tip_${slideNum}`} className={`aw_slide__tip aw_slide__tip_${slideNum}`} ref={ref => (this.tipRef = ref)}>
              <div id={`aw_slide__tip-icon_${slideNum}`} className={`aw_slide__tip-icon aw_slide__tip-icon_${slideNum}`} style={{ backgroundImage: `url(${this.props.tipIcon ? this.props.tipIcon : tipIcon})` }} />
              {this.renderTipContent()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 1
  }

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    tip: PropTypes.string,
    tipIcon: PropTypes.string,
    tipType: PropTypes.string,
    appLinks: PropTypes.object,
    bg: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
    slideNum: PropTypes.number,
  }
}

export default SlideHOC(SlideScene)



// WEBPACK FOOTER //
// ./src/templates/app-website/components/slide/SlideScene.js